import { render } from "./AddNewKeyword.vue?vue&type=template&id=96fb6474&scoped=true"
import script from "./AddNewKeyword.vue?vue&type=script&lang=js"
export * from "./AddNewKeyword.vue?vue&type=script&lang=js"

import "./AddNewKeyword.vue?vue&type=style&index=0&id=96fb6474&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96fb6474"]])

export default __exports__